import {Box, Button, Container, Typography} from "@mui/material";

const LiveTestPage = () => {

    const openGoogleMeet = (meetUrl: string) => {
        const newWindow = window.open(
            meetUrl,
            "_blank",
            "width=1400,height=900,menubar=no,toolbar=no,location=yes,status=no,resizable=yes,scrollbars=yes"
        );

        if (!newWindow) {
            alert("Popup blocked! Please allow popups.");
        }
    };

    return (
        <Container maxWidth="md">
            <Box sx={{mt: 2, p: 2, border: "1px solid #ddd"}}>
                <Typography variant="h6" mb={2}>
                    Google Meet Test
                </Typography>

                <Button
                    variant="contained"
                    onClick={() => openGoogleMeet("https://meet.google.com/huv-uecy-fhu")}
                >
                    Join Live Lesson
                </Button>
            </Box>
        </Container>
    );
};

export default LiveTestPage;